module.exports = __webpack_public_path__ + "img/gebratenenudelnseitlich.0e6de5cc.jpg";